if(typeof HorizontalTabsComponent !== 'function'){
  
  class HorizontalTabsComponent extends HTMLElement {
    constructor() {
      super();

      this.buttons = this.querySelectorAll('[data-action="tab-trigger"]') || [];
      
      if(this.buttons.length == 0) {
        this.initHotspotModal();
        return;
      }

      this.buttonActive = this.querySelector('button.active[data-action="tab-trigger"]')
      this.active = this.querySelector('tab-content.active');

      this.initHotspotModal();

      this.buttons.forEach((button) => {
        button.addEventListener('click', (e) => {
          let index = e.currentTarget.getAttribute('data-content');
          if(!index) return;

          let target = this.querySelector('tab-content[data-content="'+index+'"]');
          if(!target) return;

          this.active?.classList.remove('active');
          target.classList.add('active');
          this.active = target;

          this.buttonActive?.classList.remove('active');
          e.currentTarget.classList.add('active');
          this.buttonActive = e.currentTarget;

          setTimeout(() => this.reinitHotspots(), 50);
        });
      });
    }

    initHotspotModal() {
      const hotspotSection = this.closest('[id^="HotspotTab-"]');
      if (!hotspotSection) return;

      this.modal = hotspotSection.querySelector('.hotspot-modal');
      if (!this.modal) return;

      this.modalBody = this.modal.querySelector('.hotspot-modal-body');
      this.modalBackdrop = this.modal.querySelector('.hotspot-modal-backdrop');

      this.productContent = this.modal.querySelector('.hotspot-product-content');
      this.textContent = this.modal.querySelector('.hotspot-text-content');

      this.currentUrl = window.location.href;

      this.setupHotspots();

      if (this.modalBackdrop) {
        this.modalBackdrop.addEventListener('click', (e) => {
          this.closeModal();
        });
      }

      const modalContentContainer = this.modal.querySelector('.hotspot-modal-content');
      if (modalContentContainer) {
        modalContentContainer.addEventListener('click', (e) => {
          if (e.target === modalContentContainer) {
            this.closeModal();
          }
        });
      }

      const modalContent = this.modal.querySelector('.hotspot-modal-content > div');
      if (modalContent) {
        modalContent.addEventListener('click', (e) => {
          e.stopPropagation();
          const productUrl = modalContent.dataset.productUrl;
          if (productUrl && productUrl !== '#') {
            window.location.href = productUrl;
          }
        });
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !this.modal.classList.contains('hidden')) {
          this.closeModal();
        }
      });

      // Chiudi il modal quando l'utente naviga (back/forward del browser)
      window.addEventListener('pageshow', (e) => {
        // Chiudi sempre il modal quando la pagina viene mostrata
        if (!this.modal.classList.contains('hidden')) {
          this.closeModal();
        }
      });

      window.addEventListener('pagehide', (e) => {
        // Chiudi il modal quando la pagina sta per essere nascosta
        if (!this.modal.classList.contains('hidden')) {
          this.closeModal();
        }
      });

      // Listener per il cambio di URL (per SPA o navigazione dinamica)
      window.addEventListener('popstate', (e) => {
        if (!this.modal.classList.contains('hidden')) {
          this.closeModal();
        }
      });

      // Listener per visibilitychange (quando si cambia tab del browser)
      document.addEventListener('visibilitychange', (e) => {
        if (document.hidden && !this.modal.classList.contains('hidden')) {
          this.closeModal();
        }
      });

      // Controllo periodico per rilevare cambiamenti di URL (fallback)
      this.urlCheckInterval = setInterval(() => {
        if (this.currentUrl !== window.location.href) {
          if (!this.modal.classList.contains('hidden')) {
            this.closeModal();
          }
          this.currentUrl = window.location.href;
        }
      }, 500);
    }

    setupHotspots() {
      const hotspotSection = this.closest('[id^="HotspotTab-"]');
      if (!hotspotSection) return;

      const hotspotMobile = hotspotSection.querySelectorAll('.hotspot-mobile .hotspot');
      
      hotspotMobile.forEach((hotspot, index) => {
        if (!hotspot || !hotspot.parentNode) return;
        
        const newHotspot = hotspot.cloneNode(true);
        hotspot.parentNode.replaceChild(newHotspot, hotspot);
        
        newHotspot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          if (window.innerWidth < 1024) {
            this.openModal(newHotspot);
          }
        });
      });
    }

    reinitHotspots() {
      this.setupHotspots();
    }

    openModal(hotspotButton) {
      if (!this.modal || !this.modalBody) {
        return;
      }

      if (!this.productContent || !this.textContent) {
        this.productContent = this.modal.querySelector('.hotspot-product-content');
        this.textContent = this.modal.querySelector('.hotspot-text-content');
      }

      if (this.productContent && this.productContent.classList) {
        this.productContent.classList.add('hidden');
      }
      if (this.textContent && this.textContent.classList) {
        this.textContent.classList.add('hidden');
      }

      const productId = hotspotButton.dataset.hotspotProduct;
      const productUrl = hotspotButton.dataset.hotspotUrl;
      
      const modalContent = this.modal.querySelector('.hotspot-modal-content > div');
      if (modalContent) {
        modalContent.dataset.productUrl = productUrl || '#';
      }
      
      if (productId) {
        this.showProductModal(hotspotButton);
      } else {
        this.showTextModal(hotspotButton);
        if (modalContent) {
          modalContent.dataset.productUrl = '#';
        }
      }

      this.modal.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    }

    showProductModal(hotspotButton) {
      if (!this.productContent) {
        this.productContent = this.modal?.querySelector('.hotspot-product-content');
        if (!this.productContent) {
          return;
        }
      }

      if (!hotspotButton || !hotspotButton.dataset) {
        return;
      }

      const title = hotspotButton.dataset.hotspotTitle || '';
      const line = hotspotButton.dataset.hotspotLine || '';
      const price = hotspotButton.dataset.hotspotPrice || '';
      const comparePrice = hotspotButton.dataset.hotspotComparePrice || '';
      const productUrl = hotspotButton.dataset.hotspotUrl || '';

      const lineElement = this.productContent.querySelector('.hotspot-product-line');
      const titleElement = this.productContent.querySelector('.hotspot-product-title');
      const priceElement = this.productContent.querySelector('.hotspot-product-price');
      const comparePriceElement = this.productContent.querySelector('.hotspot-product-compare-price');

      if (lineElement) lineElement.textContent = line;
      if (titleElement) titleElement.textContent = title;
      if (priceElement) priceElement.textContent = price;
      if (comparePriceElement) {
        if (comparePrice) {
          comparePriceElement.textContent = comparePrice;
          comparePriceElement.style.display = 'inline';
        } else {
          comparePriceElement.style.display = 'none';
        }
      }

      if (this.productContent.classList) {
        this.productContent.classList.remove('hidden');
      }
    }

    showTextModal(hotspotButton) {
      if (!this.textContent) {
        this.textContent = this.modal?.querySelector('.hotspot-text-content');
        if (!this.textContent) {
          return;
        }
      }

      if (!hotspotButton || !hotspotButton.dataset) {
        return;
      }

      const title = hotspotButton.dataset.hotspotTitle || '';
      const content = hotspotButton.dataset.hotspotContent || '';

      const titleElement = this.textContent.querySelector('.hotspot-text-title');
      const bodyElement = this.textContent.querySelector('.hotspot-text-body');

      if (titleElement) titleElement.textContent = title;
      if (bodyElement) bodyElement.textContent = content;

      if (this.textContent.classList) {
        this.textContent.classList.remove('hidden');
      }
    }

    closeModal() {
      if (!this.modal) {
        return;
      }
      
      this.modal.classList.add('hidden');
      document.body.style.overflow = '';
    }

    // Cleanup quando il componente viene rimosso
    disconnectedCallback() {
      if (this.urlCheckInterval) {
        clearInterval(this.urlCheckInterval);
      }
    }
  }
  if(customElements.get('horizontal-tabs') === undefined) {
    customElements.define('horizontal-tabs', HorizontalTabsComponent);
  }
}
